import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import MemberDetailRentCabinetContentBillingRecord from '@icoach/memberDetail/MemberDetailRentCabinetContentBillingRecord';
import MemberDetailRentCabinetContentDocument from '@icoach/memberDetail/MemberDetailRentCabinetContentDocument';
import { CLUB_MEMBERS_ROUTER } from '@icoach/router/routerPath';
import { isEqual, mergeQueryToUrl } from '@util/utils';
import { MEMBER_DETAIL_TABS_MAP } from '@icoach/memberDetail/staticData';
import { TabsCardLayout } from '@icoach/components';
import useTabState from '@util/hook/useTabState';

const MemberDetailRentCabinetContent = ({ className, memberID }) => {
    const { activeTab, handleTabChange } = useTabState(MEMBER_DETAIL_TABS_MAP.RB_DOCUMENT);
    const tabData = useMemo(
        () => {
            return [
                {
                    label: '租櫃資訊',
                    value: MEMBER_DETAIL_TABS_MAP.RB_DOCUMENT,
                },
                {
                    label: '收費明細',
                    value: MEMBER_DETAIL_TABS_MAP.RB_BILLING,
                },
            ];
        },
        // eslint-disable-next-line
        [],
    );

    const actionData = useMemo(
        () => {
            return [
                {
                    label: '新增租約',
                    variant: 'outlined',
                    component: NavLink,
                    to: mergeQueryToUrl(CLUB_MEMBERS_ROUTER.CABINET.GET_CONTRACT_RENTCABINETID_PATH('contract', 0), { memberID }),
                },
            ];
        },
        // eslint-disable-next-line
        [],
    );

    return (
        <TabsCardLayout
            className={className}
            activeTab={activeTab}
            tabs={tabData}
            actions={actionData}
            onTabChange={handleTabChange}
            tabsContent={{ className: 'pt-3 px-3 pb-3' }}
        >
            {isEqual(activeTab, MEMBER_DETAIL_TABS_MAP.RB_DOCUMENT) && <MemberDetailRentCabinetContentDocument memberID={memberID} />}
            {isEqual(activeTab, MEMBER_DETAIL_TABS_MAP.RB_BILLING) && <MemberDetailRentCabinetContentBillingRecord memberID={memberID} />}
        </TabsCardLayout>
    );
};

export default MemberDetailRentCabinetContent;
